import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import UserService from "../controllers/UserService";
import AuthService from "../controllers/AuthService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';

class ReportStudentIntro extends React.Component {
    constructor(props) {
        super(props);
        this.changeData = this.changeData.bind(this);
        this.state = {
            user: AuthService.getCurrentUser(),
            role: AuthService.getUserRole(),
            evaluate: [],
            studentId: this.props.currentStudentId,
            classForDev: 'bg-gray-dev'

        };
        this.studentId = this.props.currentStudentId
        this.studentName = this.props.currentStudentName
        this.roomId = this.props.roomId

    }

    componentDidMount() {
        try {


            var user = AuthService.getCurrentUser();
            //todo ปีการศึกษา        
            var filter = {};


            UserService.getRoomDetail(this.roomId).then((response) => {
                filter = {
                    "domain": user.domain.name,
                    "roomId": this.roomId,
                    "year": response.data.data.year,
                    "term": response.data.data.term,
                };
            }).then(() => {


                UserService.getFriendShipList(this.state.studentId, filter).then((response) => {
                    if (response.data.status.code === 'SUCCESS' && response.data.data && response.data && response.data.data[0] && response.data.data[0].others) {
                        const data = response.data.data[0].others
                        const stId = this.state.studentId
                        const me = data.filter(function (d) { return d.user.id === stId })[0];
                        let t1 = data.filter(function (d) { return d.user.roles.includes("TEACHER") && d.answerAt !== null });

                        if (t1[0]) {
                            t1 = t1[0];
                        } else {
                            t1 = data.filter(function (d) { return d.user.roles.includes("TEACHER") })[0];
                        }


                        const friends = data.filter(function (d) { return d.user.roles.includes("STUDENT") && d.user.id !== stId });
                        const ansFriends = data.filter(function (d) { return d.user.roles.includes("STUDENT") && d.user.id !== stId && d.answers !== null });
                        let fText = ''
                        let fTextButton = ''
                        if (ansFriends.length === friends.length) {
                            fText = '<img src="/images/evaluate/book1-green.png" class="d-inline w-15" /> <span class="already-evaluate font-sarabun-bold">ทำประเมินครบแล้ว</span><p class="font-sarabun green-text underline-text t-14">รายละเอียด</p><br>'
                            fTextButton = `<Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold t-1" onClick="(function(){window.open('/report/friendship/export/friends/${this.roomId}/${stId}', '_blank').focus();return false;})();return false;">Export</Button>`
                        } else if (ansFriends.length === 0) {
                            fText = `<span class="gray-text4 font-sarabun t-13">เพื่อนยังไม่ได้ทำประเมิน (${ansFriends.length}/${friends.length})</span><p class="font-sarabun-bold t-14 green-text underline-text">รายละเอียด</p><br>`
                            fTextButton = `<Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold btn-disable t-12">Export</Button>`
                        } else if (ansFriends.length < friends.length) {
                            fText = `<span class="text-yellow-evaluate font-sarabun-bold">เพื่อนยังประเมินไม่ครบ (${ansFriends.length}/${friends.length})</span><p class="font-sarabun-bold t-14 green-text underline-text">รายละเอียด</p><br>`
                            fTextButton = `<Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold t-12" onClick="(function(){window.open('/report/friendship/export/friends/${this.roomId}/${stId}', '_blank').focus();return false;})();return false;">Export</Button>`
                        }

                        var status = me.answers !== null || t1.answers !== null || ansFriends.length !== 0;
                        if (status) {

                            this.setState({ classForDev: 'class-for-dev' });
                        }

                        this.setState({
                            evaluate: {
                                "me":
                                {
                                    "answer": me.answers !== null ? '<img src="/images/evaluate/book1-green.png" class="d-inline w-15" /> <span class="already-evaluate font-sarabun-bold">ทำประเมินครบแล้ว</span><p class="font-sarabun-bold t-14 green-text underline-text">รายละเอียด</p><br>' : '<span class="font-sarabun-bold grey-blue-text me-margin-bottom">ยังไม่ประเมิน</span><p class="font-sarabun-bold t-14 green-text underline-text">รายละเอียด</p><br>',
                                    "answerButton": me.answers !== null ? `<Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold t-12" onClick="(function(){window.open('/report/friendship/export/me/${this.roomId}/${stId}', '_blank').focus();return false;})();return false;">Export</Button>` : '<Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold t-12 btn-disable">Export</Button>',
                                    "done": me.answers !== null,

                                },
                                "t1":
                                {
                                    "answer": t1.answers !== null ? '<img src="/images/evaluate/book1-green.png" class="d-inline w-15" /> <span class="already-evaluate font-sarabun-bold">ทำประเมินครบแล้ว</span><p class="font-sarabun-bold green-text underline-text t-14">รายละเอียด</p><br>' : '<span class="font-sarabun-bold grey-blue-text me-margin-bottom">คุณครูยังไม่ได้ประเมิน</span><p class="font-sarabun green-text t-14 underline-text">รายละเอียด</p><br>',
                                    "answerButton": t1.answers !== null ? `<Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold t-12" onClick="(function(){window.open('/report/friendship/export/teacher/${this.roomId}/${stId}', '_blank').focus();return false;})();return false;">Export</Button>` : '<Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold t-12 btn-disable">Export</Button>',
                                    "done": t1.answers !== null,

                                },
                                "friends": {
                                    "answer": fText,
                                    "answerButton": fTextButton,
                                    "done": ansFriends.length !== 0,

                                }
                            }
                        });

                    }
                });
            });
        } catch (error) {

        }
    }

    changeData(code) {
        this.props.referenceCallback(code);
    }

    // <Col xs={4} className="px-1 px-md-3 w-100 text-center table-border click-pointer"  onClick={() => { this.changeData('studentself')  }}>
    // <Col xs={4} className="px-1 px-md-3 w-100 text-center  table-border click-pointer"  onClick={() => { this.changeData('studentteacher')  }}>
    // <Col xs={4} className="px-1 px-md-3 w-100 text-center table-border click-pointer"  onClick={() => { this.changeData('studentfriend')  }}>


    goto = (target, newTab = false) => {
        if (target && newTab) {
            window.open(target, '_blank').focus();
        }
    }

    render() {
        return (
            <div className="report-friendship">
                <Row className="bg-light-blue py-5">
                    <Col className="main-evaluate-overview pb-3 mb-3">
                        <Row>
                            <Col xs={12} md={6} className="w-100 text-center">
                                <img src='/images/evaluate/banner_overview.png' className="mb-1 d-inline pr-2 w-100" />
                            </Col>
                            <Col xs={12} md={6} className="w-100 pt-3" align="center">
                                <h3 class="font-sarabun-bold pt-md-5 primary-text">ดาวน์โหลดสมุด Friendship</h3>
                                <h3 class="font-sarabun-bold primary-text">{this.studentName}</h3>
                                <Button className="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold" onClick={() => this.goto(`/report/friendship/export/all/${this.roomId}/${this.studentId}`, true)} >Export</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col className="main-evaluate-overview">
                        <Row className="mx-2">
                            {/* <Col xs={12} md={12} className={`border-radius-12 border-blue caption-box caption-box-114 ${this.state.classForDev}`} onClick={() => { if ( this.state.classForDev ==='class-for-dev') { this.changeData('selfDevelopment') } }}>
                                <h2 class="text-center font-sarabun-bold ">แนวทางการพัฒนาตัวเอง</h2>               
                            </Col> */}
                            <Col xs={12} md={12} className={`border-radius-12 border-blue caption-box caption-box-114`}>
                                <h2 class="text-center font-sarabun-bold ">แนวทางการพัฒนาตัวเอง</h2>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-2 mt-m-3 intro-report">
                    <Col className="main-evaluate-overview p-0 p-md-3 ">
                        <Row className="mx-3 mb-5">
                            <Col xs={12} className="px-3 pt-4 pb-3 d-inline w-100 text-center">
                                <h3 className="primary-text font-sarabun-bold">ดูรายละเอียดแบบแยกมุมมอง</h3>
                            </Col>
                            <Col xs={4} className={`px-1 px-md-3 w-100 text-center table-border ${this.state.evaluate.me && this.state.evaluate.me.done ? '-click-pointer' : ''}`} style={{ "position": "relative" }}>
                                <img src='/images/report-friendship/me.png' className="pt-3 round-icon" />
                                <h4 className="font-sarabun-bold grey-dark-text">มุมมองตัวเอง</h4>
                                <p dangerouslySetInnerHTML={{ __html: this.state.evaluate.me && this.state.evaluate.me.answer ? this.state.evaluate.me.answer : '' }} className={this.state.evaluate.me && this.state.evaluate.me.done ? 'click-pointer' : ''} onClick={() => { if (this.state.evaluate.me && this.state.evaluate.me.done) { this.changeData('studentself') } }} /><br></br>
                                <p dangerouslySetInnerHTML={{ __html: this.state.evaluate.me && this.state.evaluate.me.answerButton ? this.state.evaluate.me.answerButton : '' }} style={{ "position": "absolute", "width": "100%", "bottom": "0px", "right": "0px" }} />
                            </Col>
                            <Col xs={4} className={`px-1 px-md-3 w-100 text-center table-border ${this.state.evaluate.t1 && this.state.evaluate.t1.done ? '-click-pointer' : ''}`} style={{ "position": "relative" }}>
                                <img src='/images/report-friendship/teacher.png' className="pt-3 round-icon" />
                                <h4 className="font-sarabun-bold grey-dark-text">มุมมองคุณครู</h4>
                                <p dangerouslySetInnerHTML={{ __html: this.state.evaluate.t1 && this.state.evaluate.t1.answer ? this.state.evaluate.t1.answer : '' }} className={this.state.evaluate.t1 && this.state.evaluate.t1.done ? 'click-pointer' : ''} onClick={() => { if (this.state.evaluate.t1 && this.state.evaluate.t1.done) { this.changeData('studentteacher') } }} /><br></br>
                                <p dangerouslySetInnerHTML={{ __html: this.state.evaluate.t1 && this.state.evaluate.t1.answerButton ? this.state.evaluate.t1.answerButton : '' }} className={this.state.evaluate.t1 && this.state.evaluate.t1.done ? 'click-pointer' : ''} style={{ "position": "absolute", "width": "100%", "bottom": "0px", "right": "0px" }} />
                            </Col>
                            <Col xs={4} className={`px-1 px-md-3 w-100 text-center table-border ${this.state.evaluate.friends && this.state.evaluate.friends.done ? '-click-pointer' : ''}`} style={{ "position": "relative" }}>
                                <img src='/images/report-friendship/friends.png' className="pt-3 round-icon" />
                                <h4 className="font-sarabun-bold grey-dark-text">มุมมองเพื่อน</h4>
                                <p dangerouslySetInnerHTML={{ __html: this.state.evaluate.friends && this.state.evaluate.friends.answer ? this.state.evaluate.friends.answer : '' }} className={this.state.evaluate.friends && this.state.evaluate.friends.done ? 'click-pointer' : ''} onClick={() => { if (this.state.evaluate.friends && this.state.evaluate.friends.done) { this.changeData('studentfriend') } }} /><br></br>
                                <p dangerouslySetInnerHTML={{ __html: this.state.evaluate.friends && this.state.evaluate.friends.answerButton ? this.state.evaluate.friends.answerButton : '' }} style={{ "position": "absolute", "width": "100%", "bottom": "0px", "right": "0px" }} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default ReportStudentIntro
